module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAXAQMAAADNxtYqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAGUExURQAAAOcsLuwtGYsAAAABdFJOUwBA5thmAAAAF0lEQVQI12P4////DwYEQQQgR8cDJAIA7QMgWT3LS5AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-menu/icon-mobile_menu.png
// module id = 822
// module chunks = 0